export default __webpack_public_path__ + "static/media/volumerender.577c12fd.vert";